import {
  COUNTRIES_FETCHING,
  FETCH_COUNTRIES,
  FILTER_COUNTRIES_BY_PATTERN,
  FIND_COUNTRY,
} from "../actions/types";

const initialState = {
  items: [],
  filteredItems: [],
  found: null,
  isFetching: false,
  limit: 0,
  offset: 0,
  loader: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case COUNTRIES_FETCHING:
      return { ...state, isFetching: true };

    case FETCH_COUNTRIES:
      return {
        ...state,
        items: action.payload.items,
        isFetching: false,
      };

    case FIND_COUNTRY:
      return {
        ...state,
        found: action.payload,
      };

    default:
      return state;
  }
}
